import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[OnlyNumbers]'
})
export class OnlyNumbersDirective {

  constructor(private _el: ElementRef) { }
  @HostListener('keypress', ['$event']) oninput(e) {
   
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
   
    return !!/[\d\s]/.test(input);
  }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    let input;
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    let input;
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    let input;
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  @HostListener('drop', ['$event']) blockdragEnded(e: KeyboardEvent) {
    let input;
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }
}
